import React from 'react';

import './Card.scss';

interface ICardProps {}

export const Card: React.FunctionComponent<ICardProps> = ({children}) => {
    return <div className="Card__container">{children}</div>;
};
